// extracted by mini-css-extract-plugin
module.exports = {"yesBtn":"_2ieQW","noBtn":"_2mIqH"};